import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

// Material-UI Icon
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'

// Custom Style
import {whiteColor, redColor, oceanBlueColor, grayColor} from '../../styles/jss/cmsMainStyle'
import readingStatusFormStyle from '../../styles/jss/components/circulation/readingStatusFormStyle'

// Fetch Data
import {getCirculationReadStatus} from '../../dataSource/circulation'


const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: oceanBlueColor[8],
		color: whiteColor,
		fontSize: 20,
	},

	body: {
		fontSize: 15,
	},
}))(TableCell)
  
const StyledTableRow = withStyles((theme) => ({
	root: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow)


const useStyles = makeStyles(theme => readingStatusFormStyle(theme))
const store = require('store')

const ReadingStatusForm = props => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const {circulationSeq} = props

	// Define Status
	const [readStatusRecord, setReadStatusRecord] = useState(null)

	function createData(name, recipientCategory, status, readingDate) {
		return {name, recipientCategory, status, readingDate}
	}


	useEffect(() => {

		if (circulationSeq) {
			let tempRecord = []

			getCirculationReadStatus(circulationSeq).then(records => {
				records.data.map(record => {
					tempRecord = [...tempRecord, createData(record.message_rcpt_user_fullname, record.rcpt_category, record.is_read, record.read_date)]
				})
				setReadStatusRecord(tempRecord)
			})
		}

	}, [])


	return (
		// console.log("Selected circulation Seq | Variable: circulationSeq (CirculationReplyForm.js)"),
		// console.log(circulationSeq),

		// console.log("Read Status Table Record | Variable: readStatusRecord (CirculationReplyForm.js)"),
		// console.log(readStatusRecord),

		// console.log("Circulation Detail Source Data | Variable: circulationDetail (CirculationReplyForm.js)"),
		// console.log(circulationDetail),

		// console.log("Circulation Reply Data | Variable: circulationData (CirculationReplyForm.js)"),
		// console.log(circulationData),

		// console.log("Circulation Reply Data (Redux) | Variable: circulationDataRedux (CirculationReplyForm.js)"),
		// console.log(circulationDataRedux),

		// console.log("CKEditor Value | Variable: editorValue (CirculationReplyForm.js)"),
		// console.log(editorValue),
		
		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>

			<TableContainer component={Paper}>
				<Table aria-label="reading status table">
					<TableHead>
						<TableRow>
							<StyledTableCell>Name</StyledTableCell>
							<StyledTableCell align="center">Reciptent Category</StyledTableCell>
							<StyledTableCell align="center">Read</StyledTableCell>
							<StyledTableCell align="center">Read Date</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{
							readStatusRecord ?
								readStatusRecord.map(row => (
									<StyledTableRow key={row.name}>
										<StyledTableCell component="th" scope="row">{row.name}</StyledTableCell>
										<StyledTableCell align="center">{row.recipientCategory === "FROM" ? "SENDER" : row.recipientCategory === "TO" ? "RECIPTENT" : ""}</StyledTableCell>
										<StyledTableCell align="center">{row.status ? <CheckCircleIcon className={classes.read} /> : <CancelIcon className={classes.unread} />}</StyledTableCell>
										<StyledTableCell align="center">{row.readingDate}</StyledTableCell>
									</StyledTableRow>
								))
							: ""
						}
					</TableBody>
				</Table>
			</TableContainer>

		</Fragment>
	)
}


export default ReadingStatusForm